import { alpha } from "@mui/material/styles";
// ----------------------------------------------------------------------
export function select(theme) {
    return {
        MuiSelect: {
            // defaultProps: {
            //   IconComponent: ChevronDown
            // },
            styleOverrides: {
                root: {
                    borderRadius: "40px",
                    color: "#637381",
                    fontSize: 15,
                    fontWeight: 500,
                    "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: alpha(theme.palette.primary.main, 0.4),
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: alpha(theme.palette.primary.main, 0.6),
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: theme.palette.primary.main,
                    },
                },
                select: {
                    padding: "12px 16px",
                    fontWeight: 500,
                    fontSize: 15,
                },
                icon: {
                    right: 16,
                    width: 18,
                    height: 18,
                    top: "calc(50% - 9px)",
                    color: "#637381",
                },
            },
        },
        MuiNativeSelect: {
            styleOverrides: {
                icon: {
                    right: 18,
                    width: 18,
                    height: 18,
                    top: "calc(50% - 9px)",
                },
            },
        },
        MuiPopover: {
            styleOverrides: {
                paper: {
                    maxHeight: "500px !important",
                    overflowY: "auto",
                },
            },
        },
    };
}
